import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adobeCloud = defineConnector({
  identifier: "adobeCloud",
  name: "Adobe Cloud",
  tagLine: "Server-to-server Adobe APIs",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://[^/]*\\.adobe\\.(io|com)/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        scheme: "Bearer",
        value: app.oauthToken.accessToken,
      },
      {
        name: "x-gw-ims-org-id",
        value: app.config.organizationId,
      },
    ]),
  steps: [
    {
      title: "Create an OAuth Server-to-Server credential",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Adobe Developer Console](https://developer.adobe.com/console/), open your project and add an **OAuth Server-to-Server** credential. Copy the **Client ID**, **Client Secret**, **Scopes**, and **Organization ID** from the credentials page.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Scopes",
          required: true,
          placeholder: "openid, AdobeID, read_organizations",
          helperText: "Comma-separated scopes listed on the credentials page.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          placeholder: "XXXXXXXXXXXXXXXXXXXXXXXX@AdobeOrg",
          target: { kind: "configuration", field: "organizationId" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://ims-na1.adobelogin.com/ims/token/v3",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://ims-na1.adobelogin.com/ims/validate_token/v1",
      method: "POST",
      expectedStatus: [200, 400],
    }),
  },
});
